import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components/macro'
import colors from 'styles/colors'
import media from 'styles/mixins/media'
import { themeImage } from 'TrackApp'

const MapCanvas = styled.div`
  height: 52.5rem;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.greyLight};
  border-left: none;
  border-right: none;

  ${media.mobile`
    height: 30rem;
  `}
`

function latlngsForRoute(route) {
  const decodedPath = window.google.maps.geometry.encoding.decodePath(route)
  return decodedPath.filter(segment => segment && segment.lat() && segment.lng())
}

function showRoute(map, latLngs, color=colors.primaryBase){
  const poly = new window.google.maps.Polyline({
    strokeColor: color,
    strokeOpacity: 1.0,
    strokeWeight: 7.0,
    clickable: false
  })
  poly.setPath(latLngs)
  poly.setMap(map)
}

function buildMap(el) {
  return new window.google.maps.Map(el, {
    zoom: 15,
    minZoom: 3,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    scrollwheel: false,
    rotateControl: false,
    panControl: false,
    draggable: false,
    disableDoubleClickZoom: true,
    mapTypeControl: false,
  })
}

function setMarker(map, position, icon){
  new window.google.maps.Marker({ position, map, icon })
}

function routeIcon(themeName, url, size=55) {
  return {
    url: themeImage(themeName, url),
    size: new window.google.maps.Size(size*2,size*2),
    origin: new window.google.maps.Point(0,0),
    anchor: new window.google.maps.Point(size/2,size/2),
    scaledSize: new window.google.maps.Size(size,size)
  }
}

class TrackingMap extends Component {

  setup(map) {
    const { tracking, theme, themeName, live } = this.props
    const routeLatLngs = latlngsForRoute(tracking.route)
    
    showRoute(map, routeLatLngs, this.props.theme.colors.primaryBase)
  
    const pickupLatLng = new window.google.maps.LatLng(tracking.pickup_location.latitude, tracking.pickup_location.longitude)
    const deliveryLatLng = new window.google.maps.LatLng(tracking.delivery_location.latitude, tracking.delivery_location.longitude)

    setMarker(map, pickupLatLng, routeIcon(themeName, theme.map.markers.start))
    setMarker(map, deliveryLatLng, routeIcon(themeName, theme.map.markers.end))
  
    const mapBounds = new window.google.maps.LatLngBounds()
    routeLatLngs.forEach(function(latLng) {
      mapBounds.extend(latLng)
    })

    if (live && tracking.roadie && tracking.roadie.location && !tracking.events.find(e => e.event_type === 'delivery_confirmed')) {
      const currentLngLng = new window.google.maps.LatLng(tracking.roadie.location.latitude, tracking.roadie.location.longitude)
      setMarker(map, currentLngLng, routeIcon(themeName, theme.map.markers.location, 62))
      mapBounds.extend(currentLngLng)
    }

    map.fitBounds(mapBounds, 0)
  }

  handleMapRef = el => {
    this.map = el ? buildMap(el) : null
    if (this.map) {
      this.setup(this.map)
    }
  }

  render() {
    return <MapCanvas className={this.props.className} ref={this.handleMapRef} />
  }
}

export default withTheme(TrackingMap)